import { c as _c } from "react/compiler-runtime";
import { RichTagsFunction, useTranslations } from 'next-intl';
export type OnAccepted = () => void;
export const GuidelinesStep2FA = t0 => {
  const $ = _c(44);
  const {
    onAccepted
  } = t0;
  const t = useTranslations("GuidelineForm");
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = _temp;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t10;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[1] !== t) {
    const commonValues = {
      strong: t1
    };
    t10 = "m-10";
    t7 = "my-2 list-decimal";
    let t11;
    if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
      t11 = <br />;
      $[11] = t11;
    } else {
      t11 = $[11];
    }
    t8 = <li className="my-2">{t.rich("step1_title", commonValues)}{t11}{t("step1_description")}<ul className="list-inside list-disc"><li>{t.rich("step1_option1", commonValues)}</li><li>{t.rich("step1_option2", commonValues)}</li><li>{t.rich("step1_option3", commonValues)}</li></ul>{t.rich("step1_note", commonValues)}</li>;
    let t12;
    if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
      t12 = <br />;
      $[12] = t12;
    } else {
      t12 = $[12];
    }
    t9 = <li className="my-2">{t.rich("step2_title", commonValues)}{t12}{t("step2_description")}</li>;
    t5 = "my-2";
    t6 = t.rich("step3_title_2FA", commonValues);
    t3 = "list-inside list-disc";
    t4 = <li>{t.rich("step3_environment_2FA", commonValues)}</li>;
    t2 = t.rich("step3_verification_2FA", commonValues);
    $[1] = t;
    $[2] = t10;
    $[3] = t2;
    $[4] = t3;
    $[5] = t4;
    $[6] = t5;
    $[7] = t6;
    $[8] = t7;
    $[9] = t8;
    $[10] = t9;
  } else {
    t10 = $[2];
    t2 = $[3];
    t3 = $[4];
    t4 = $[5];
    t5 = $[6];
    t6 = $[7];
    t7 = $[8];
    t8 = $[9];
    t9 = $[10];
  }
  let t11;
  if ($[13] !== t2) {
    t11 = <li>{t2}</li>;
    $[13] = t2;
    $[14] = t11;
  } else {
    t11 = $[14];
  }
  let t12;
  if ($[15] !== t11 || $[16] !== t3 || $[17] !== t4) {
    t12 = <ul className={t3}>{t4}{t11}</ul>;
    $[15] = t11;
    $[16] = t3;
    $[17] = t4;
    $[18] = t12;
  } else {
    t12 = $[18];
  }
  let t13;
  if ($[19] !== t12 || $[20] !== t5 || $[21] !== t6) {
    t13 = <li className={t5}>{t6}{t12}</li>;
    $[19] = t12;
    $[20] = t5;
    $[21] = t6;
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  let t14;
  if ($[23] !== t13 || $[24] !== t7 || $[25] !== t8 || $[26] !== t9) {
    t14 = <ol className={t7}>{t8}{t9}{t13}</ol>;
    $[23] = t13;
    $[24] = t7;
    $[25] = t8;
    $[26] = t9;
    $[27] = t14;
  } else {
    t14 = $[27];
  }
  let t15;
  if ($[28] !== t) {
    t15 = t("support");
    $[28] = t;
    $[29] = t15;
  } else {
    t15 = $[29];
  }
  let t16;
  if ($[30] !== t15) {
    t16 = <p className="my-2">{t15}</p>;
    $[30] = t15;
    $[31] = t16;
  } else {
    t16 = $[31];
  }
  let t17;
  if ($[32] !== onAccepted) {
    t17 = () => onAccepted();
    $[32] = onAccepted;
    $[33] = t17;
  } else {
    t17 = $[33];
  }
  let t18;
  if ($[34] !== t) {
    t18 = t("accept");
    $[34] = t;
    $[35] = t18;
  } else {
    t18 = $[35];
  }
  let t19;
  if ($[36] !== t17 || $[37] !== t18) {
    t19 = <div className="flex flex-row justify-end p-2"><button className="btn btn-primary" onClick={t17}>{t18}</button></div>;
    $[36] = t17;
    $[37] = t18;
    $[38] = t19;
  } else {
    t19 = $[38];
  }
  let t20;
  if ($[39] !== t10 || $[40] !== t14 || $[41] !== t16 || $[42] !== t19) {
    t20 = <><div className={t10}>{t14}{t16}{t19}</div></>;
    $[39] = t10;
    $[40] = t14;
    $[41] = t16;
    $[42] = t19;
    $[43] = t20;
  } else {
    t20 = $[43];
  }
  return t20;
};
function _temp(chunks) {
  return <strong>{chunks}</strong>;
}